//群标签
//data 接受总数据
import React, {forwardRef,useEffect,useState,useImperativeHandle} from 'react';
import {Input, Radio} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {Empty} from "antd/es";
import tag_empty from "../../../../images/common/customer/tag/tag_empty.png";
import Message from "../../../common/message";
const ZkSelectGroupLabel=forwardRef((props,ref)=>{
    const [data,setData]=useState(props.data)//全部的标签数据
    const [newData,setNewData]=useState(props.data)
    const [selectData,setSelectData]=useState([]);//已选中的数据
    const [value,setValue]=useState('')//模糊搜索
    const [radioValue,setRadioValue]=useState( 1)//筛选条件的单选按钮
    useEffect(()=>{
        setData(props.data)
        let selectList=[]
        props.data.forEach((item,index)=>{
            item.tag.forEach((el,ind)=>{
                if(el.flag){
                    selectList.push(el)
                }
            })
        })
        setSelectData(selectList)
    },[JSON.stringify(props.data)])

    useEffect(()=>{
        setRadioValue(props.filterType || 1)
    },[JSON.stringify(props.filterType)])

    //筛选条件的事件
    function onChange(e) {
        setRadioValue(e.target.value);
    }
    //点击标签
    function LabelLeftBtns(id) {
        let list = JSON.parse(JSON.stringify(data))
        let str = []
        list.forEach((item,index)=>{
            item.tag.forEach((el,ind)=>{
                if(el.id == id){
                    el.flag=!el.flag
                }
                if (el.flag) {
                    str.push(el)
                }
            })
        })
        if(str.length > 10){
            Message.warning('最多添加10个标签')
            return;
        }else {
            setData(list)
        }

    }
    //模糊搜
    function labelInput(e) {
        let value=e.target.value
        setValue(value)
        let filterData=[]
        newData.forEach((tagGroup,index)=>{
            let matchTag = tagGroup.tag.filter((el,ind)=>{
                return el.name.indexOf(value)!=-1
            })
            if(matchTag.length >0 ){
                let group = {"groupId":tagGroup.groupId,"groupName":tagGroup.groupName};
                group.tag = matchTag;
                filterData.push(group)
            }
        })
        if(value==''){
            setData(newData)
        }else {
            setData(filterData)
        }
    }
    function exportName(){
        let list=JSON.parse(JSON.stringify(data))
        let selectName=[]
        list.forEach((item,index)=>{
            item.tag.forEach((el,ind)=>{
                if(el.flag){
                    selectName.push(el.name)
                }
            })
        })
        return selectName
    }
    function exportId(){
        let list=JSON.parse(JSON.stringify(data))
        let selectId=[]
        list.forEach((item,index)=>{
            item.tag.forEach((el,ind)=>{
                if(el.flag){
                    selectId.push(el.id)
                }
            })
        })
        return selectId
    }
    function exportData(){
        return data
    }
    function exportRadioValue(){
        return radioValue
    }
    useImperativeHandle(ref, () => ({
        exportName:exportName,
        exportId:exportId,
        exportData:exportData,
        exportRadioValue:exportRadioValue
    }));
    return(
        <ul className={'SelectLabel'}>
            <li>
                <div>筛选条件：</div>
                <Radio.Group onChange={onChange} value={radioValue}>
                    <Radio value={1}>以下标签满足其中之一</Radio>
                    <Radio value={2}>以下标签同时满足</Radio>
                </Radio.Group>
            </li>
            <div style={{height: '10px'}}></div>
            <div className={'group_chat_sop_label'}>
                <Input
                    placeholder="请输入要查找的标签"
                    suffix={<SearchOutlined/>}
                    value={value}
                    onChange={labelInput}
                />
            </div>
            <div className={'group_chat_sop_label_list'}>
                {
                    data.length == 0 ? <div style={{marginTop: '12px', fontWeight: '600'}}>
                        <Empty image={tag_empty} description={'没有搜到相关企业标签哦~'}/>
                    </div> : <>
                        {data && data.map((item,index)=>{
                            return <div key={item.groupId}>
                                <div>{item.groupName}：</div>
                                <div className={'label_array'}>
                                    {item.tag && item.tag.map((el,ind)=>{
                                        return <span
                                            key={el.id}
                                            className={el.flag ? 'pitch_on' : 'unselected'}
                                            onClick={LabelLeftBtns.bind(this,el.id)}
                                        >
                                            {el.name}
                                        </span>
                                    })}
                                </div>
                            </div>
                        })}
                    </>
                }
            </div>
        </ul>
    )
})
export default ZkSelectGroupLabel
